<template>
    <!-- nav-holder-->
    <div class="nav-holder but-hol">
        <div class="nav-scroll-bar-wrap fl-wrap">
            <router-link to="/" class="logo_menu">
                <img :src="logoUrl" :alt="siteName">
            </router-link>
            <div class="nav-container fl-wrap">
                <!-- nav -->
                <nav class="nav-inner" id="menu">
                    <ul>
                        <li>
                            <router-link to="/">
                                Home
                            </router-link>
                        </li>
                        <template v-for="page in pages" :key="page.id">
                            <li v-if="page.slug !== 'home'">
                                <router-link :to="'/pages/' + page.slug">
                                    {{ page.title }}
                                </router-link>
                            </li>
                        </template>

                        <li>
                            <router-link to="/contact">
                                Contact
                            </router-link>
                        </li>
                    </ul>
                </nav>
                <!-- nav end-->
            </div>
        </div>
        <!-- nav-title-->
        <div class="nav-holder-line"></div>
        <div class="nav-title"><span>Menu</span></div>
        <!-- nav-title end-->
    </div>
    <div class="nav-holder-dec"></div>
    <div class="nav-overlay"></div>
    <!-- nav-holder end -->
</template>

<script>
import { useSiteDefaultsStore } from '@/stores/siteDefaultsStore'

export default {
    name: 'Navigation',
    data() {
        return {
            siteDefaultsStore: null,
            logoUrl: '',
            siteName: '',
            pages: []
        }
    },
    async mounted() {
        this.siteDefaultsStore = useSiteDefaultsStore()
        
        // Load initial data
        this.updateFromStore()
        
        // Listen for site defaults updates
        this.siteDefaultsStore.onSiteDefaultsLoaded(() => {
            this.updateFromStore()
        })
        
        // Load pages for navigation
        await this.loadPages()
        
        // Initialize menu after pages are loaded
        this.$nextTick(() => {
            setTimeout(() => {
                this.initMenu()
            }, 100)
        })
    },
    beforeUnmount() {
        if (this.siteDefaultsStore) {
            this.siteDefaultsStore.offAllEvents()
        }
        
        // Clean up menu event handlers
        const $ = window.jQuery
        if ($) {
            $(".nav-button").off("click")
            $(".nav-overlay").off("click")
            
            // Don't destroy nicescroll - we never initialized it
            console.log('✅ Navigation cleanup complete')
        }
    },
    methods: {
        updateFromStore() {
            if (this.siteDefaultsStore) {
                this.logoUrl = this.siteDefaultsStore.getLogoDark() || '/assets/img/logo2.png'
                this.siteName = this.siteDefaultsStore.getSiteName() || 'Upatto'
            }
        },
        
        async loadPages() {
            try {
                const response = await this.$api.get('public/pages/list')
                if (response.data) {
                    this.pages = response.data.data || []
                    console.log('✅ Loaded', this.pages.length, 'navigation pages')
                }
            } catch (error) {
                console.error('❌ Failed to load pages for navigation:', error)
                this.pages = []
            }
        },
        
        initMenu() {
            const $ = window.jQuery
            const TweenMax = window.TweenMax
            const Expo = window.Expo
            
            if (!$ || !$("#menu").length) {
                console.warn('⚠️ jQuery or menu element not available')
                return
            }
            
            console.log('🍔 Initializing navigation menu...')
            
            // Initialize jQuery menu plugin
            $("#menu").menu()
            
            // Add submenu decoration class
            $(".sliding-menu li a.nav").parent("li").addClass("submen-dec")
            
            // DON'T initialize nicescroll - it conflicts with navigation
            // Let it scroll naturally instead
            console.log('✨ Skipping nicescroll to avoid conflicts')
            
            // Menu show/hide functionality
            const nbw = $(".nav-button")
            const nhw = $(".nav-holder")
            const nho = $(".nav-overlay")
            const nhd = $(".nav-holder-dec")
            
            const showMenu = () => {
                nho.fadeIn(500)
                if (TweenMax && Expo) {
                    TweenMax.to(nhd, 1.2, {
                        force3D: true,
                        left: "0",
                        ease: Expo.easeInOut
                    })
                    TweenMax.to(nhw, 1.2, {
                        force3D: true,
                        left: "0",
                        delay: 0.2,
                        ease: Expo.easeInOut
                    })
                }
                nhw.removeClass("but-hol")
                nbw.addClass("cmenu")
                setTimeout(function () {
                    if ($.fn.shuffleLetters) {
                        $(".nav-title span").shuffleLetters({})
                    }
                }, 950)
            }
            
            const hideMenu = () => {
                if (TweenMax && Expo) {
                    TweenMax.to(nhw, 1.2, {
                        force3D: true,
                        left: "-600px",
                        ease: Expo.easeInOut
                    })
                    TweenMax.to(nhd, 1.2, {
                        force3D: true,
                        left: "-600px",
                        delay: 0.2,
                        ease: Expo.easeInOut
                    })
                }
                nhw.addClass("but-hol")
                nbw.removeClass("cmenu")
                nho.fadeOut(500)
            }
            
            // Navigation button click handler
            nbw.off("click").on("click", function () {
                if (nhw.hasClass("but-hol")) showMenu()
                else hideMenu()
            })
            
            // Overlay click handler
            nho.off("click").on("click", function () {
                hideMenu()
            })
            
            // Add shuffle letters effect on hover
            if ($.fn.shuffleLetters) {
                $(".sliding-menu a, .grid-det-item a").on({
                    mouseenter: function () {
                        $(this).shuffleLetters({})
                    }
                })
            }
            
            // IMPORTANT: Close menu when any link is clicked
            $(".sliding-menu a").off("click.closemenu").on("click.closemenu", function(e) {
                console.log('🔗 Menu link clicked - closing menu')
                hideMenu()
            })
            
            console.log('✅ Navigation menu initialized')
        }
    }
}
</script>

